<!-- src/layouts/document.vue -->
<template>
  <v-app>
    <AppHeader />
    <v-main class="pa-8">
      <router-view />
    </v-main>
  </v-app>
</template>
